import { TenantContext } from "./TenantContext";

interface TenantProps {
  config: any;
  children: React.ReactNode;
}

const TenantProvider = ({ config, children }: TenantProps) => {
  config.mainLogo = require(`../../assets/${config.name}/logo.png`);
  return (
    <TenantContext.Provider
      value={{
        config: config,
      }}
    >
      {children}
    </TenantContext.Provider>
  );
};

export default TenantProvider;
